// extracted by mini-css-extract-plugin
export var button = "_m1-2";
export var card = "_m1-0";
export var closeButtonContainer = "_m1-3";
export var iconContainer = "_m1-1";